<main class="mb-4" *ngIf="isCommonDataLoaded">
  <div class="row ">
    <div class="col-sm-12">
      <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepSender.Cards.SenderIdentification.Title' | translate}}</h2>
    </div>
  </div>

  @if(parentWorkflow.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary !== null && parentWorkflow.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary !== undefined){

  <ng-content *ngIf="parentWorkflow.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString()!='true';else serviceOrFunerary">
    <div class="row ">

      <!--Nome-->
      <div class="col-sm-8">
        <div class="form-group">
          <fieldset [disabled]="isFieldDisabled('name')" required>
            <label for="name" [ngClass]="{'disabled': isFieldDisabled('name')}">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepSender.Cards.SenderIdentification.Fields.Name' | translate}}
            </label>
            <div class="position-relative">
              <input class="form-control input-right" type="text" [(ngModel)]="cardData.name"
                     #name="ngModel" name="name"
                     maxlength="60"
                     placeholder="{{'PrestacoesMorte.StepSender.Cards.SenderIdentification.Fields.NamePlaceholder' | translate}}"
                     messageFieldType="string">

              <validation-message [control]="name"></validation-message>
            </div>
          </fieldset>
        </div>
      </div>

      <!--Data de Nascimento-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset [disabled]="isFieldDisabled('dateOfBirth')" required>
            <label for="dateOfBirth" [ngClass]="{'disabled': isFieldDisabled('dateOfBirth')}">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepSender.Cards.SenderIdentification.Fields.DateOfBirth' | translate}}
            </label>
            <div class="form-row">
              <div class="input-group col-sm-12">
                <input #dpDateOfBirth="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                       placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                       [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                       [(ngModel)]="cardData.dateOfBirth" name="dateOfBirth"
                       maxlength="10" disabled
                       #dateOfBirth="ngModel" />
                <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfBirth.isDisabled && dpDateOfBirth.toggle()">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="icon-calendar"></i>
                  </span>
                </div>
                <validation-message [control]="dateOfBirth"></validation-message>
              </div>
            </div>
          </fieldset>
        </div>

      </div>
    </div>

    <div class="row">

      <!--Tem nacionalidade portuguesa?-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset [disabled]="isFieldDisabled('hasNacPT')" required>
            <label for="hasPortugueseNationality" [ngClass]="{'disabled': isFieldDisabled('hasNacPT')}">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNationality' | translate}}
            </label>
            <div class="btn-group btn-group-toggle maxWidth">
              <label *ngFor="let domain of yesNo.slice().reverse()"
                     class="btn btn-toogle"
                     [class.active]="domain.value==cardData.hasNacPT?.toString()"
                     [radioLabel]="hasPortugueseNationality">
                <input type="radio"
                       [(ngModel)]="cardData.hasNacPT"
                       name="hasPortugueseNationality"
                       [clearRelated]="{model : this.cardData , propsToReset : ['identificationNumberFirst','identificationNumberLast']}"
                       (change)="hasPortugueseNationalityChange(cardData.hasNacPT)"
                       #hasPortugueseNationality="ngModel"
                       [value]="domain.value">
                {{domain.description}}
              </label>
              <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
              <!--<span>cardData.hasNacPT:{{cardData.hasNacPT}}</span>-->
            </div>
          </fieldset>
        </div>


        


      </div>



      



      <!--Tem nif portugues?-->
      <!--<div class="col-sm-4">
        <div class="form-group">
          <fieldset [disabled]="isFieldDisabled('hasNIFPT')">
            <label for="hasPortugueseNif" [ngClass]="{'disabled': isFieldDisabled('hasNIFPT')}">
                <span class="mandatory" >*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNif' | translate}}
            </label>
            <div class="btn-group btn-group-toggle maxWidth">
              <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle" [class.active]="domain.value==cardData.hasNIFPT?.toString()" [radioLabel]="hasPortugueseNif">
                <input type="radio"
                       [(ngModel)]="cardData.hasNIFPT"
                       name="hasPortugueseNif"
                       #hasPortugueseNif="ngModel"
                       [value]="domain.value">
                {{domain.description}}
              </label>
              <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
            </div>
          </fieldset>
        </div>
      </div>-->
      <!--Nacionalidade-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset [disabled]="isFieldDisabled('nationality')">
            <label for="nationality" [ngClass]="{'disabled': isFieldDisabled('nationality')}">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.Nationality' | translate}}
            </label>
            <select class="custom-select"
                    [(ngModel)]="cardData.nationality"
                    name="nationalityCode"
                    #nationalityCode="ngModel"
                    required
                    [dropdownTitle]="{value : cardData.nationality, dimension : nationalities }"
                    nullableSelect>
              <default-dropdown-values></default-dropdown-values>
              <option *ngFor="let domain of nationalities" [value]="domain.code">
                {{domain.description}}
              </option>
            </select>
            <validation-message [control]="nationalityCode"></validation-message>
          </fieldset>
        </div>
      </div>






    </div>

    <div class="row">
      <!--Genero-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset disabled>
            <label for="Gender" class="disabled">
              <span *ngIf="isServiceOrFunerary==false" class="mandatory">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.Gender' | translate}}
            </label>
            <select class="custom-select"
                    [(ngModel)]="cardData.gender"
                    name="gender"
                    #gender="ngModel"
                    [dropdownTitle]="{value : cardData.gender, dimensions :  genders }"
                    nullableSelect
                    required>
              <default-dropdown-values></default-dropdown-values>
              <option *ngFor="let domain of genders" [value]="domain.code">
                {{domain.description}}
              </option>
            </select>
            <validation-message [control]="gender"></validation-message>
          </fieldset>
        </div>
      </div>

      <!--Estado civil na data do óbito-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset [disabled]="isFieldDisabled('civilState')">
            <label for="MaritalStatus" [ngClass]="{'disabled': isFieldDisabled('civilState')}">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.CivilState' | translate}}
            </label>
            <select class="custom-select"
                    [(ngModel)]="cardData.civilState"
                    name="civilState"
                    #civilState="ngModel"
                    required
                    nullableSelect>
              <default-dropdown-values></default-dropdown-values>
              <option *ngFor="let domain of maritalStatus" [value]="domain.description">
                {{domain.value}}
              </option>
            </select>
            <validation-message [control]="civilState"></validation-message>
          </fieldset>
        </div>
      </div>
    </div>

    <div class="row">
      <!--Tipo de documento de identificação-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset disabled>
            <label for="DocumentType" class="disabled">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.IdentificationDocumentType' | translate}}
            </label>
            <select class="custom-select"
                    [(ngModel)]="cardData.identificationDocumentType"
                    name="identificationDocumentType"
                    #identificationDocumentType="ngModel"
                    [dropdownTitle]="{value : cardData.identificationDocumentType, dimensions : documentTypes }"
                    nullableSelect>
              <default-dropdown-values></default-dropdown-values>
              <option *ngFor="let domain of documentTypes" [value]="domain.code">
                {{domain.description}}
              </option>
            </select>
            <validation-message [control]="identificationDocumentType"></validation-message>
          </fieldset>
        </div>

      </div>

      <!--Número de identificação-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset disabled>
            <label for="identificationNumber" [ngClass]="{'disabled': isFieldDisabled('identificationNumberFirst')}">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.IdentificationNumber' | translate}}
            </label>
            @if(cardData.identificationDocumentType !='P' ){
            <div class="form-row">
              <div class="col-sm-9">
                <input class="form-control"
                       type="text"
                       numeric="8"
                       required
                       [disabled]="isFieldDisabled('identificationNumberFirst')"
                       [(ngModel)]="cardData.identificationNumberFirst"
                       name="identificationNumberFirst"
                       #identificationNumberFirst="ngModel"
                       maxlength="8">
              </div>
              <div class="col-sm-3">
                <input class="form-control"
                       type="text"
                       maxlength="4"
                       [(ngModel)]="cardData.identificationNumberLast"
                       [disabled]="isFieldDisabled('identificationNumberLast')"
                       name="identificationNumberLast"
                       #identificationNumberLast="ngModel">
              </div>
            </div>
            <validation-message [control]="identificationNumberFirst"></validation-message>
            } @else {
            <div class="form-row">
              <div class="col-sm-9">
                <input class="form-control"
                       type="text"
                       mask="A*"
                       required
                       [disabled]="isFieldDisabled('identificationNumberFirst')"
                       [(ngModel)]="cardData.identificationNumberFirst"
                       name="identificationNumberFirst"
                       #identificationNumberFirst="ngModel"
                       maxlength="10">
              </div>
              <div class="col-sm-3">
                <input class="form-control"
                       type="text"
                       maxlength="4"
                       [(ngModel)]="cardData.identificationNumberLast"
                       [disabled]="isFieldDisabled('identificationNumberLast')"
                       name="identificationNumberLast"
                       #identificationNumberLast="ngModel">
              </div>
            </div>
            <validation-message [control]="identificationNumberFirst"></validation-message>

            }
          </fieldset>
        </div>
      </div>

      <!--NIF-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset [disabled]="!(cardData.hasNIFPT?.toString()==='true') || isFieldDisabled('NIF')">
            <label for="NIF" [ngClass]="{'disabled': !(cardData.hasNIFPT?.toString()==='true') || isFieldDisabled('NIF') }">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.NIF' | translate}}
            </label>
            <input class="form-control"
                   type="number"
                   numeric="9"
                   [(ngModel)]="cardData.NIF"
                   name="NIF"
                   #NIF="ngModel"
                   maxlength="9"
                   nifValidation
                   [required]="cardData.hasNIFPT?.toString()==='true'">
            <validation-message [control]="NIF"></validation-message>
          </fieldset>
        </div>
      </div>
    </div>



  </ng-content>
  <ng-template #serviceOrFunerary>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label class="disabled" for="code">{{'CardServiceIdentification.Code' | translate}}</label>
          <input class="form-control" type="text" numeric="7" placeholder="{{'CardServiceIdentification.Code' | translate}}" [(ngModel)]="cardData.serviceCode" name="code" #code="ngModel" disabled>
          <validation-message [control]="code"></validation-message>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="form-group">
          <label class="disabled" for="designation">{{'CardServiceIdentification.Designation' | translate}}</label>
          <input class="form-control" placeholder="{{'CardServiceIdentification.Designation' | translate}}" [(ngModel)]="cardData.name"
                 maxlength="60"
                 name="designation" #designation="ngModel" disabled>
          <validation-message [control]="designation"></validation-message>
        </div>
      </div>
    </div>
    <div class="row">
      <!--NIF-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset disabled>
            <label for="NIF" class="disabled"><span class="mandatory">*</span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.NIF' | translate}}</label>
            <input class="form-control"
                   type="number"
                   numeric="9"
                   [(ngModel)]="cardData.NIF"
                   name="NIF"
                   #NIF="ngModel"
                   maxlength="9">
            <validation-message [control]="NIF"></validation-message>
          </fieldset>
        </div>
      </div>
    </div>
  </ng-template>

  }
  <div class="row">
    <div class="form-group text-secondary col-sm-12" style="font-size:90%;">
      <label style="display:block">
        {{'PrestacoesMorte.StepSender.Cards.SenderIdentification.Messages.PersonalData' | translate}}
      </label>
    </div>
  </div>


</main>
